import React from 'react';
import { useTranslation } from 'react-i18next';

const LOGO_URL = "/logo.png";

const StampCard = ({ stamps = 0, stampsRequired = 10, rewardAvailable = false, compact = false }) => {
  const { t } = useTranslation();

  if (compact) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1C1C22]/80 border border-zinc-700" data-testid="stamp-card-compact">
        <img src={LOGO_URL} alt="" className="h-4 w-4" />
        <span className="text-xs font-bold text-[#FFC107]">{stamps}/{stampsRequired}</span>
      </div>
    );
  }

  return (
    <div className="w-full max-w-sm mx-auto" data-testid="stamp-card">
      <div className="relative bg-gradient-to-br from-[#141417] via-[#141417] to-[#1C1C22] rounded-2xl border border-[#3F3F46] overflow-hidden">
        {/* Gold accent top bar */}
        <div className="h-1.5 bg-gradient-to-r from-[#FFC107] via-[#FFD54F] to-[#FFC107]" />
        
        {/* Header */}
        <div className="px-5 pt-4 pb-2 flex items-center justify-between">
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider font-['Barlow_Condensed']">
              {t('loyalty.title')}
            </h3>
            <p className="text-[10px] text-zinc-500 mt-0.5">{t('loyalty.collectStamps')}</p>
          </div>
          <div className="text-right">
            <span className="text-2xl font-bold text-[#FFC107] font-['Barlow_Condensed']">{stamps}</span>
            <span className="text-xs text-zinc-500">/{stampsRequired}</span>
          </div>
        </div>

        {/* Stamps Grid */}
        <div className="px-5 py-3">
          <div className="grid grid-cols-5 gap-2">
            {Array.from({ length: stampsRequired }).map((_, i) => (
              <div
                key={i}
                className={`aspect-square rounded-xl relative flex items-center justify-center transition-all duration-300 ${
                  i < stamps
                    ? 'bg-[#FFC107]/15 border-2 border-[#FFC107]/50 shadow-[0_0_8px_rgba(255,193,7,0.2)]'
                    : 'bg-[#1C1C22]/50 border-2 border-zinc-700/50 border-dashed'
                }`}
                data-testid={`stamp-${i}-${i < stamps ? 'filled' : 'empty'}`}
              >
                {i < stamps ? (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="flex flex-col items-center" style={{ transform: 'translateY(-7px)' }}>
                      <img
                        src={LOGO_URL}
                        alt="Stamp"
                        className="w-12 h-12 object-contain drop-shadow-[0_0_4px_rgba(255,193,7,0.4)]"
                        style={{ marginBottom: '-11px' }}
                      />
                      <span className="text-[6px] font-bold tracking-wider leading-none"><span className="text-[#FFC107]">TASTY</span><span className="text-white">BITES</span></span>
                    </div>
                  </div>
                ) : (
                  <span className="text-[10px] font-bold text-zinc-600">{i + 1}</span>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Progress bar */}
        <div className="px-5 pb-2">
          <div className="h-1 bg-[#1C1C22] rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-[#FFC107] to-[#FFD54F] rounded-full transition-all duration-500"
              style={{ width: `${(stamps / stampsRequired) * 100}%` }}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="px-5 pb-4 pt-1">
          {rewardAvailable ? (
            <div className="text-center py-2 px-3 bg-[#FFC107]/10 rounded-lg border border-[#FFC107]/30" data-testid="reward-available-badge">
              <p className="text-xs font-bold text-[#FFC107] uppercase tracking-wider">
                {t('loyalty.rewardReady')}
              </p>
              <p className="text-[10px] text-zinc-400 mt-0.5">{t('loyalty.redeemNext')}</p>
            </div>
          ) : (
            <p className="text-[10px] text-zinc-500 text-center">
              {t('loyalty.stampsToGo', { count: stampsRequired - stamps })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StampCard;
